import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M5 8.5C2.744 8.5 1.15 6.779.384 5.952a1.42 1.42 0 0 1 0-1.943C1.08 3.259 2.708 1.5 5 1.5s3.92 1.758 4.616 2.509a1.42 1.42 0 0 1 0 1.943C8.85 6.779 7.256 8.5 5 8.5M5 3a4.95 4.95 0 0 0-3.346 1.847.25.25 0 0 0 .009.352A5.18 5.18 0 0 0 5 7a4.9 4.9 0 0 0 3.31-1.847.25.25 0 0 0 0-.344A4.9 4.9 0 0 0 5 3"
    }, null, -1),
    createElementVNode("path", {
      fill: "currentColor",
      d: "M3.75 5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 1 0-2.5 0"
    }, null, -1)
  ]));
}
const interfaceEditViewEye = { render };
export {
  interfaceEditViewEye as default,
  render
};
//# sourceMappingURL=interface-edit-view-eye.svg.js.map
